function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "event-black-18dp_1_",
  "data-name": "event-black-18dp (1)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,0H18V18H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M11.556,14H1.445A1.425,1.425,0,0,1,0,12.6L.007,2.8A1.42,1.42,0,0,1,1.445,1.4h.722V0H3.611V1.4H9.389V0h1.444V1.4h.723A1.424,1.424,0,0,1,13,2.8v9.8A1.424,1.424,0,0,1,11.556,14ZM2,6v6h9V6Zm7,5H6V8H9v3Z",
  transform: "translate(2 2)",
  fill: "#878787"
}));

var SvgIconCalendarDate = function SvgIconCalendarDate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Calendar_1",
    "data-name": "Icon Calendar 1",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCalendarDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-calendar-date.668ef5b2.svg";
export { ForwardRef as ReactComponent };